import React from "react";
import "./Toggle.scss";

export interface FullToggleProps {
  checked: boolean;
  options: [string, string];
  setChecked: (next: boolean) => void;
  disabled?: boolean;
}

export function FullToggle(props: FullToggleProps) {
  const { checked, options, setChecked, disabled = false } = props;

  return (
    <div
      onClick={() => !disabled && setChecked(!checked)}
      className={`toggle ${disabled ? "disabled" : "active"}`}
    >
      <div className={!checked ? "checked" : ""}>{options[0]}</div>
      <div className={checked ? "checked" : ""}>{options[1]}</div>
    </div>
  );
}
